import React from 'react';
import { Table, Row, Col, Pagination, Form } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useTable, usePagination } from "react-table";
import { tableHeader } from "./tableHeader";
import ListButton from './ListButton';

export const UsersTable = (props) => {
    const navigate = useNavigate();
    // const location = useLocation();
    const columns = tableHeader;
    const data = props.users;
    const app_id = props.app_id;
    
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex, pageSize },
        } = useTable(
        {
            columns,
            data,
            initialState: { pageIndex: 0 }
        },
        usePagination
    )                           
    return (
        <>
            <Table striped bordered {...getTableProps()}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => (
                            <th>
                                {column.render("Header")}
                            </th>
                        ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {data && data.length < 1 && 
                        <tr className='text-center'>
                            <td colSpan={5}>No records found</td>
                        </tr>
                    }
                    {page.map((row, i) => {
                        prepareRow(row);
                        return (
                            <tr {...row.getRowProps()}>
                                {row.cells.map((cell, index, row) => {
                                    if (cell.column.id === 'roles') {
                                        const roles = (cell.value
                                            .filter(value => value.name).map(value => (value.name))).sort();
                                        return(
                                        <td {...cell.getCellProps()}>
                                            {
                                                (roles.map(value => (<div>{value}</div>)))
                                            }
                                        </td>);
                                    }
                                    if (cell.column.id === 'sequence_no') {
                                       return <td key={cell.column.id}>{cell.row.index + 1}</td>
                                    }

                                    if (index + 1 === row.length) {
                                        return (
                                            <td key={index} className='d-flex align-items-start'>
                                                <ListButton
                                                    app_id={app_id}
                                                    cell={cell.row.original}
                                                />
                                            </td>
                                        );
                                    }
                                    return (
                                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                                    );
                                })}
                            </tr>
                           
                        )
                    })}

                    
                </tbody>
            </Table>
            <Row>
                <Col md="6">
                <span className="mx-2">
                    Page{" "}
                    <strong>
                    {pageIndex + 1} of {pageOptions.length}
                    </strong>
                </span>
                <span className="ms-3 me-2">Show:</span>
                <Form.Select
                    className="d-inline-block w-auto"
                    value={pageSize}
                    onChange={(e) => {
                    setPageSize(Number(e.target.value));
                    }}
                >
                    {[10, 20, 30, 40, 50].map((pageSize) => (
                    <option key={pageSize} value={pageSize}>
                        {pageSize}
                    </option>
                    ))}
                </Form.Select>

                <span className="ms-3 me-2">Go to page:</span>
                <Form.Control
                    className="d-inline-block"
                    type="number"
                    defaultValue={pageIndex + 1}
                    onChange={(e) => {
                    const page = e.target.value ? Number(e.target.value) - 1 : 0;
                    gotoPage(page);
                    }}
                    style={{ width: "75px" }}
                />
                </Col>
                <Col md="6">
                    <Pagination className="float-end">
                        <Pagination.First
                            onClick={() => gotoPage(0)}
                            disabled={!canPreviousPage}
                        />
                        <Pagination.Prev
                            onClick={() => previousPage()}
                            disabled={!canPreviousPage}
                        />
                        <Pagination.Next
                            onClick={() => nextPage()}
                            disabled={!canNextPage}
                        />
                        <Pagination.Last
                            onClick={() => gotoPage(pageCount - 1)}
                            disabled={!canNextPage}
                        />
                    </Pagination>
                </Col>
            </Row>
           
        </>
    )
}